import { logOut } from "@actions/userActions";
import { store } from "@store/index";
import { isPrintRenderContext } from "@utils/printRenderScope";

// Returns true when the failure ended the session.
export function handleAuthFailure(error: any): boolean {
  if (error?.response?.status !== 401) return false;
  console.error(error);
  if (isPrintRenderContext()) {
    console.error(
      "[print] request rejected with 401 — the render token scope is probably missing a UUID",
    );
    return false;
  }
  store.dispatch(logOut("/login"));
  return true;
}
